import helper from '../helpers'
import * as config from '../config'
import {Align} from "../class/align";

export default class Loading extends Phaser.Scene {

    constructor() {
        super({
            key: 'Loading'
        });
    }

    preload() {
        this.graphics = this.add.graphics();
        this.newGraphics = this.add.graphics();
        let progressBar = new Phaser.Geom.Rectangle(config.width / 2 - 400, config.height / 2, 800, 80);
        let progressBarFill = new Phaser.Geom.Rectangle(config.width / 2, config.height / 2, 580, 70);
        this.graphics.fillStyle(0xffffff, 1);
        this.graphics.fillRectShape(progressBar);

        this.newGraphics.fillStyle(0x3587e2, 1);
        this.newGraphics.fillRectShape(progressBarFill);

        this.loadingText = this.add.text(config.width / 2 - 410,config.height / 2 + 100,"Загрузка: ", { fontSize: '88px', fill: '#FFF' });

        this.load.image('code', './image/sprites/code.png');
        this.load.image('bug', './image/sprites/bug.png');
        this.load.image('coin', './image/sprites/coin.png');
        this.load.image('wall', './image/sprites/block.png');
        this.load.image('bullet', './image/sprites/hidden.png');
        this.load.image('deadline', './image/deadline.png');
        this.load.image('background', './image/background.png');
        this.load.atlas(
            "character",
            './image/boy/frame.png',
            './image/boy/frame.json'
        );
        this.load.image('game_manager', './image/manager/manager.png')
        // this.load.atlas(
        //     "game_manager",
        //     './image/manager/frame.png',
        //     './image/manager/frame.json'
        // );


        this.load.on('progress',
            (value) => {
                this.updateBar(value)
            },
            {
            newGraphics:this.newGraphics,
            loadingText:this.loadingText
        });
    }

    updateBar(value) {
        this.newGraphics.clear();
        this.newGraphics.fillStyle(0x3587e2, 1);
        this.newGraphics.fillRectShape(new Phaser.Geom.Rectangle(config.width / 2 - 395, config.height / 2 + 5, value*790, 70));

        value = value * 100;
        this.loadingText.setText("Loading: " + value.toFixed(2) + "%");
    }

    create() {
        helper.gameStart();
        this.scene.start('Game');
        this.scene.stop('Loading');
    }
}
